import { useEffect, useState } from "react";
import { AggregateScoreType, DocumentType } from "~/operations";
import { AdjustedAggregateScoreType } from "../types";

type useFirewatchPageProps = {
  pageType: AdjustedAggregateScoreType;
};

export function useFirewatchPage({ pageType }: useFirewatchPageProps) {
  const [minRiskValue, setMinRiskValue] = useState<number | null>(null);
  const [findingMrn, setFindingMrn] = useState<string | null>(null);

  useEffect(() => {
    if (pageType === AggregateScoreType.Asset) {
      // Set the max risk score to 99 for the Exposed Assets page, this will give us only the assets that are truly affected
      setMinRiskValue(1);
      setFindingMrn("//security.api.mondoo.app/findings/vulns");
    } else if (pageType === AggregateScoreType.Advisory) {
      setMinRiskValue(1);
      setFindingMrn(null);
    } else if (pageType === AggregateScoreType.Vulnerability) {
      setMinRiskValue(1);
      setFindingMrn(null);
    } else {
      setMinRiskValue(null);
      setFindingMrn(null);
    }
  }, [pageType]);

  const determineGeneratedReportType = ():
    | DocumentType.VulnerabilitiesReport
    | DocumentType.ChecksReport
    | undefined => {
    switch (pageType) {
      case AggregateScoreType.Advisory:
      case AggregateScoreType.Vulnerability:
      case AggregateScoreType.Software:
      case AggregateScoreType.Asset:
        return DocumentType.VulnerabilitiesReport;
      case AggregateScoreType.Check:
        return DocumentType.ChecksReport;

      default:
        return undefined;
    }
  };

  const documentType = determineGeneratedReportType();

  return { minRiskValue, findingMrn, documentType };
}
